import { Component, DestroyRef, inject, Input } from '@angular/core';
import { NgbActiveOffcanvas, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DetailedListContact } from '../../../../models/detailed-list.model';
import { DetailedListClient } from '../../../../models/detailed-list-client.model';
import { StatusCliente } from 'src/app/pages/call-center/pages/status-config/model/status.model';
import { CustomMessage } from 'src/app/pages/call-center/pages/status-config/model/custom-message.model';
import { ContactService } from '../../../../contact.service';
import { StatusConfigService } from 'src/app/pages/call-center/pages/status-config/services/status-config.service';
import { ToastService } from 'src/app/shared/toasts/toast-service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ProjetoFormModalComponent } from 'src/app/pages/call-center/pages/projects/pages/projeto-form-modal/projeto-form-modal.component';
import { detailedQualifiedListTourSteps } from './detailed-qualified-list.tour';

@Component({
  selector: 'app-detailed-qualified-list',
  templateUrl: './detailed-qualified-list.component.html',
  styleUrl: './detailed-qualified-list.component.scss'
})
export class DetailedQualifiedListComponent {
  @Input() client!: DetailedListContact;

  destroyedRef = inject(DestroyRef);
  clientRequest: DetailedListClient | null = null;
  statusMessages: StatusCliente[] = [];
  customMessages: CustomMessage[] | null = null;
  selectedCustomMessage: CustomMessage | null = null;
  statusId = "";
  message = "";
  scheduledDate = "";
  qualify = false;
  isLoading = false;
  novaMensagemForm!: FormGroup;
  informacoesClienteExpandido = false; // Controla se o container está expandido (inicia minimizado)
  mostrarCheckboxProjeto = false; // Controla a visibilidade do checkbox "Projeto foi criado?"

  constructor(
    private contactService: ContactService,
    private statusConfigService: StatusConfigService,
    private offcanvasService: NgbActiveOffcanvas,
    private toastService: ToastService,
    private fb: FormBuilder,
    private router: Router,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
    

    this.novaMensagemForm = this.fb.group({
      statusId: [],
      mensagemPersonalizada: [],
      mensagem: ['', Validators.required],
      dataAgendamento: [null],
      qualificarContato: [false],
      removerContato: [false],
      removerDosQualificados: [false], // true = removerDaLista = true, false = removerDaLista = false
      projetoFoiCriado: [false]
    })

    // Controlar visibilidade do checkbox "Projeto foi criado?" e resetar quando desmarcado
    this.novaMensagemForm.get('removerDosQualificados')?.valueChanges
      .pipe(takeUntilDestroyed(this.destroyedRef))
      .subscribe((value) => {
        this.mostrarCheckboxProjeto = value === true;
        if (!value) {
          this.novaMensagemForm.patchValue({ projetoFoiCriado: false }, { emitEvent: false });
        }
      });

    // Consulta followUp Atual
    this.contactService
      .getDetailedListClient(this.client.contatoGeradoId)
      .pipe(takeUntilDestroyed(this.destroyedRef))
      .subscribe({
        next: (client) => {
          this.clientRequest = client;
          this.scheduledDate =
            client.dataAgendamento &&
            new Date(client.dataAgendamento).toISOString().split("T")[0];
          this.statusId = client.statusClienteId;

          // Atualizando os valores no formulário
          this.novaMensagemForm.patchValue({
            statusId: client.statusClienteId,
            mensagem: '', // Se necessário, insira algum valor inicial
            dataAgendamento: client.dataAgendamento
              ? new Date(client.dataAgendamento).toISOString().split("T")[0]
              : null,
            qualificarContato: false, // Ajuste de acordo com os dados que deseja preencher
            removerContato: false,   // Ajuste de acordo com os dados que deseja preencher
          });
        },
        error: (error) => {
          console.error(error);
        },
      });

    // Consulta lista de status para selectListitem
    this.statusConfigService
      .getStatusMessages()
      .pipe(takeUntilDestroyed(this.destroyedRef))
      .subscribe({
        next: (status) => {
          this.statusMessages = status;
        },
        error: (error) => {
          console.error(error);
        },
      });

    this.statusConfigService
      .getCustomMessages()
      .pipe(takeUntilDestroyed(this.destroyedRef))
      .subscribe({
        next: (customMessages) => {
          this.customMessages = customMessages;
        },
        error: (error) => {
          console.error(error);
        },
      });
  }
  onSubmit(event: Event) {
    if (this.novaMensagemForm.invalid) {
      this.novaMensagemForm.markAllAsTouched();

      // Iterar sobre os campos e exibir os erros
      Object.keys(this.novaMensagemForm.controls).forEach((field) => {
        const control = this.novaMensagemForm.get(field);
        if (control?.errors) {
          console.log(`Erro no campo "${field}":`, control.errors);
        }
      });

      return;
    }

    const formValues = this.novaMensagemForm.value;

    if (this.novaMensagemForm.valid) {

      this.isLoading = true;

      // Determinar removerDaLista baseado no checkbox
      // Se selecionado: true, se não selecionado: false (mantendo lógica anterior)
      const removerDaLista = formValues.removerDosQualificados === true;
      
      // Determinar projetoCriado baseado no checkbox
      // true quando marcado, false quando desmarcado ou quando o checkbox não está visível
      const projetoCriado = !!formValues.projetoFoiCriado;

      const data = {
        id: this.client.contatoGeradoId,
        statusClienteId: formValues.statusId,
        mensagem: formValues.mensagem,
        dataAgendamento: formValues.dataAgendamento,
        qualificarContato: formValues.qualificarContato,
        removerDaLista: removerDaLista,
        projetoCriado: projetoCriado
      };

      this.contactService
        .saveDetailedListClientData(data)
        .pipe(takeUntilDestroyed(this.destroyedRef))
        .subscribe({
          next: (result) => {
            this.offcanvasService.close();
            this.isLoading = false;
            this.toastService.show("Cliente atualizado com sucesso", {
              classname: "bg-success text-light",
            });
          },
          error: (error) => {
            this.toastService.show("Erro ao atualizar cliente", {
              classname: "bg-danger text-light",
            });
          },
        });
    }

  }

  onMensagemSelecionada(event: Event): void {
    const selectedMessageId = (event.target as HTMLSelectElement).value;

    if (selectedMessageId) {
      this.selectedCustomMessage = this.customMessages?.find(
        (msg) => msg.id === selectedMessageId
      ) || null;

      // Atualizando o valor do campo 'mensagem' no formulário
      this.novaMensagemForm.patchValue({
        mensagem: this.selectedCustomMessage?.mensagem || ''
      });
    }
  }

  onClose() {
    this.offcanvasService.close();
  }

  onConfirm() { }

  toggleInformacoesCliente(): void {
    this.informacoesClienteExpandido = !this.informacoesClienteExpandido;
  }

  novoProjeto(): void {
    const modalRef = this.modalService.open(ProjetoFormModalComponent, {
      size: 'md',
      backdrop: 'static'
    });

    modalRef.result.then(
      (result) => {
        if (result === 'created') {
          this.toastService.show('Projeto criado com sucesso!', {
            classname: 'bg-success text-light',
          });
        }
      },
      (dismissed) => {
        // Modal foi fechado sem ação
      }
    );
  }

  navegarParaProjeto(clienteid?:string, feiraid?:string) {
    this.router.navigate([`clientes/${clienteid}`], { queryParams: { extra: 2}});

    this.onClose();
  }

  iniciarTour(): void {
    // Aguardar um pouco para garantir que o DOM está renderizado
    setTimeout(() => {
      // Verificar se pelo menos um elemento do tour existe
      const primeiroElemento = document.querySelector(detailedQualifiedListTourSteps[0]?.element);
      
      if (!primeiroElemento) {
        console.warn('Elementos do tour não encontrados. Verifique se a modal carregou completamente.');
        return;
      }

      // Importar e usar driver.js
      import('driver.js').then((driverModule) => {
        const { driver } = driverModule;
        
        if (!driver) {
          console.error('Driver.js não foi carregado corretamente.');
          return;
        }
        
        // Filtrar apenas os steps cujos elementos existem no DOM
        const stepsValidos = detailedQualifiedListTourSteps.filter((step) => {
          const elemento = document.querySelector(step.element);
          return elemento !== null;
        });

        if (stepsValidos.length === 0) {
          console.warn('Nenhum elemento do tour está visível.');
          return;
        }

        // Configuração do driver
        const driverObj = driver({
          showProgress: true,
          steps: stepsValidos,
          allowClose: true,
          overlayOpacity: 0.75,
          stagePadding: 4,
          stageRadius: 5,
          smoothScroll: true,
          animate: true,
          onHighlightStarted: (element: any) => {
            // Garantir que o overlay seja criado e visível
            setTimeout(() => {
              const overlayEl = document.querySelector('.driver-overlay') as HTMLElement;
              if (overlayEl) {
                overlayEl.style.display = 'block';
                overlayEl.style.opacity = '0.75';
                overlayEl.style.zIndex = '9998';
              }
            }, 50);
          },
          onPopoverRender: (popover: any, options: any) => {
            // Traduzir botões para português
            setTimeout(() => {
              const popoverEl = document.querySelector('.driver-popover') as HTMLElement;
              if (popoverEl) {
                // Traduzir apenas os textos dos botões
                const buttons = popoverEl.querySelectorAll('button');
                buttons.forEach((btn) => {
                  const text = btn.textContent?.trim();
                  if (text === 'Next') {
                    btn.textContent = 'Próximo';
                  } else if (text === 'Previous') {
                    btn.textContent = 'Anterior';
                  }
                });
                
                // Se for o primeiro step (resumo geral), centralizar no meio da tela
                if (options?.state?.activeIndex === 0) {
                  // Forçar recálculo das dimensões
                  popoverEl.style.display = 'block';
                  popoverEl.style.visibility = 'visible';
                  
                  // Obter dimensões reais do popover
                  const popoverRect = popoverEl.getBoundingClientRect();
                  const windowWidth = window.innerWidth;
                  const windowHeight = window.innerHeight;
                  
                  // Calcular posição central
                  const left = Math.max(20, (windowWidth - popoverRect.width) / 2);
                  const top = Math.max(20, (windowHeight - popoverRect.height) / 2);
                  
                  // Aplicar posição centralizada com !important para sobrescrever estilos do Driver.js
                  popoverEl.style.setProperty('position', 'fixed', 'important');
                  popoverEl.style.setProperty('left', `${left}px`, 'important');
                  popoverEl.style.setProperty('top', `${top}px`, 'important');
                  popoverEl.style.setProperty('right', 'auto', 'important');
                  popoverEl.style.setProperty('bottom', 'auto', 'important');
                  popoverEl.style.setProperty('transform', 'none', 'important');
                  popoverEl.style.setProperty('margin', '0', 'important');
                }
              }
              
              // Garantir que o overlay esteja visível
              const overlayEl = document.querySelector('.driver-overlay') as HTMLElement;
              if (overlayEl) {
                overlayEl.style.display = 'block';
                overlayEl.style.opacity = '0.75';
                overlayEl.style.zIndex = '9998';
              }
            }, 150);
          }
        });

        // Iniciar o tour
        driverObj.drive();
      }).catch((error) => {
        console.error('Erro ao carregar Driver.js:', error);
      });
    }, 300);
  }
}
